import React from "react";

const SvgFB = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 26"
    fill="none"
  >
    <path
      d="M25 13.3008C25 6.39722 19.4036 0.800781 12.5 0.800781C5.59644 0.800781 0 6.39722 0 13.3008C0 19.5399 4.57106 24.7112 10.5469 25.6489V16.9141H7.37305V13.3008H10.5469V10.5469C10.5469 7.41406 12.413 5.6836 15.2683 5.6836C16.6359 5.6836 18.0664 5.92773 18.0664 5.92773V9.00391H16.4902C14.9374 9.00391 14.4531 9.96746 14.4531 10.956V13.3008H17.9199L17.3657 16.9141H14.4531V25.6489C20.4289 24.7112 25 19.5399 25 13.3008Z"
      fill="#1877F2"
    />
    <path
      d="M17.3677 16.9141L17.9219 13.3008H14.4551V10.956C14.4551 9.96746 14.9393 9.0039 16.4921 9.0039H18.0684V5.92773C18.0684 5.92773 16.6379 5.68359 15.2703 5.68359C12.415 5.68359 10.5488 7.41405 10.5488 10.5469V13.3008H7.375V16.9141H10.5488V25.6489C11.1949 25.7502 11.848 25.8009 12.502 25.8008C13.1664 25.8008 13.8187 25.7488 14.4551 25.6489V16.9141H17.3677Z"
      fill="white"
    />
  </svg>
);

export default SvgFB;
